import moment from 'moment-timezone'

export const convertDate = (value, checkFormat) => {
  const settings = JSON.parse(localStorage.getItem('userSettings'))
  return moment
    .utc(value)
    .tz(moment.tz.guess())
    .format(
      checkFormat ? 'MM/DD/YY HH:mm' : settings['datetime'].dateTimeFormat,
    )
}

export const convertFilterDate = value => {
  return moment.utc(value)
}

/**
 * LPA-162 — COST SEG PRO (LEGACY) IS DOLLARS-NATIVE. READ THIS BEFORE WIRING
 * ANY PAYMENTS FIELD INTO THIS APP.
 *
 * Every money value csp-ui handles today — takeoff costs, estimates, indirect
 * costs, actual costs, depreciation figures — arrives from csp-api in DOLLARS,
 * and this formatter (plus currencyRenderer.js and roundOffCurrencyRenders.js)
 * assumes that. There is no cents-to-dollars boundary in this repo, and there
 * deliberately is not one: an unused convention is a convention nobody keeps.
 *
 * The rest of the estate is NOT dollars-native. Payments (platform-services)
 * reports every money field on the wire in integer CENTS as a `long` — order
 * amounts, credit balances, loyalty spend, promo discounts, refunds. Passing
 * one of those to formatCurrency below renders it 100x too high, which is
 * LPA-87 exactly: a $3,377.92 annual spend printed as "$337,792".
 *
 * If csp-ui ever reads a Payments field, do NOT divide by 100 at the call site
 * — that per-call-site convention is the whole reason LPA-162 exists. Port
 * `src/app/helpers/money.ts` from ccs-ui, solutions-ui or dash-ui (all three
 * carry byte-identical copies) and render through `formatMoneyFromCents`.
 *
 * The same warning is on rd-ui's `src/app/services/format.service.ts`, the
 * other dollars-native frontend.
 */
export const formatCurrency = value => {
  const settings = JSON.parse(localStorage.getItem('userSettings'))
  if (value) {
    return new Intl.NumberFormat(settings['currency'].currencyFormate, {
      style: 'currency',
      currency: settings['currency'].currency,
    }).format(value)
  } else {
    return new Intl.NumberFormat(settings['currency'].currencyFormate, {
      style: 'currency',
      currency: settings['currency'].currency,
    }).format(0)
  }
}

export const formatNumber = value => {
  const settings = JSON.parse(localStorage.getItem('userSettings'))
  if (value) {
    return new Intl.NumberFormat(settings['currency'].currencyFormate, {
      maximumSignificantDigits: 20,
    }).format(value)
  } else {
    return new Intl.NumberFormat(settings['currency'].currencyFormate, {
      maximumSignificantDigits: 20,
    }).format(0)
  }
}

export const formatValue = (value, precision) => {
  return Math.trunc(value * Math.pow(10, precision)) / Math.pow(10, precision)
}

export const checkNegative = value => {
  return value < 0
}

export const timeConvert = (data) => {
  if (data) {
    const hour = Math.floor(data / 3600)
    const minute = Math.floor(data % 3600 / 60)
    const seconds = Math.floor(data % 3600 % 60)
    const hDisplay = checkNumberDigits(hour)
    const mDisplay = checkNumberDigits(minute)
    const sDisplay = checkNumberDigits(seconds)
    return `${hDisplay}:${mDisplay}:${sDisplay}`
  }
  return '00:00:00'
}

export const checkNumberDigits = (data) => {
  return data > 0 ? (data < 10 ? '0' + data : data) : '00'
}

export const formatPercentage = (value) => {
  const settings = JSON.parse(localStorage.getItem('userSettings'))
  return new Intl.NumberFormat(settings['currency'].currencyFormate, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}
